import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { type CreateOrderDTO } from "./dto";
import { toaster } from "@/components/ui/toaster";
import { createOrder } from "./api";

import { invalidator } from "@shared/react-query";

type UpdateCompanyResult = Awaited<ReturnType<typeof createOrder>>;

interface Args extends UseMutationOptions<
  UpdateCompanyResult,
  Error,
  CreateOrderDTO
> {}

export const useCreateOrderMutation = ({ onSuccess, ...args }: Args = {}) => {
  return useMutation<UpdateCompanyResult, Error, CreateOrderDTO>({
    mutationFn: (vars) => createOrder(vars),
    onSuccess: (...result) => {
      invalidator().byEntity("order");
      onSuccess?.(...result);
    },
    onError: (error) => {
      toaster.error({
        title: "Failed to create order",
        description: error.message,
      });
    },
    ...args,
  });
};
